module.exports = __webpack_public_path__ + "img/인플레이 로고.1bbe1809.png";